import { Button, ButtonGroup } from "react-bootstrap";
import { toast } from "react-toastify";

const CopyShare = ({ text }) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Copied to clipboard!");
    } catch (err) {
      console.error("Copy failed", err);
      toast.error("Failed to copy.");
    }
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Check this out!",
          text,
        });
        //  toast.success("Shared successfully!");
      } catch (err) {
        console.error("Share failed", err);
        toast.error("Failed to share.");
      }
    } else {
      toast.info("Sharing not supported in this browser.");
    }
  };

  return (
    <ButtonGroup>
      <Button variant="outline-primary" onClick={handleCopy}>
        Copy
      </Button>
      <Button variant="success" onClick={handleShare}>
        Share
      </Button>
    </ButtonGroup>
  );
};

export default CopyShare;
